/* 30/09 perf fiche : sur la fiche produit, démarre juste APRÈS le 1er affichage (#almea-pdp-pret) — élément caché, prêt quelques ms après. */
/* 30/09 perf : ce fichier est chargé en « async » (il ne bloque plus l'affichage de la page).
   Il attend son repère #almk-search (posé juste avant la balise script) pour démarrer exactement au même moment qu'avant.
   Sans repère sur la page : il démarre à la fin du chargement. */
(function almBoot(){
  if (document.readyState === 'loading' && (!document.getElementById('almk-search') || (document.getElementById('almea-render-barrier') && !document.getElementById('almea-pdp-pret')))) { setTimeout(almBoot, 20); return; }
/* ══════════════════════════════════════════════════════════════════════════
   Maison Alméa — Vignettes de COLLECTION dans le panneau de recherche (loupe)
   01/09/2026

   POURQUOI CE FICHIER
   Le bloc « Collection / Produit / Blog / Pages » a été retiré du panneau : personne
   ne cherche un article de blog depuis la loupe. À la place, les collections qui
   correspondent à la recherche s'affichent en photo, juste au-dessus des produits.

   Le fichier qui construit les résultats (almea-overlay-enhance.js) n'existe pas sur
   le PC, il ne vit que sur le thème : on injecte donc par-dessus plutôt que de le
   modifier. Et ce code est dans un asset, pas dans la section, parce que
   z-header-masazen.liquid frôle la limite Shopify de 256 Ko.

   Les collections viennent de /search/suggest.json : aucune donnée en dur, la liste
   suit automatiquement les collections de la boutique.

   ⚠️ IDEMPOTENT : un drapeau `data-q` sur le conteneur empêche toute réinjection.
   Sans lui, écrire dans le DOM depuis un MutationObserver qui surveille ce même DOM
   fige la page (incident du 01/09, voir memory/lecons/theme-shopify.md).
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  if (window.__almSoCols) return;
  window.__almSoCols = true;

  var cache = {};

  function champ() {
    return document.getElementById('mzSoInput') ||
           document.querySelector('#mzSearchOverlay .mz-so-input');
  }

  function dessiner(box, cols) {
    box.innerHTML = cols.map(function (c) {
      var img = c.featured_image && c.featured_image.url ? c.featured_image.url : '';
      return '<a class="alm-socol" href="' + c.url + '">' +
             (img ? '<img src="' + img.split('?')[0] + '?width=480" alt="" loading="lazy">' : '') +
             '<span>' + c.title + '</span></a>';
    }).join('');
  }

  function poser() {
    var res = document.getElementById('mzSoResults');
    if (!res) return;
    /* Il existe plusieurs conteneurs de grille dans le panneau, dont un vide en fin de
       document. On vise donc la grille REELLE, celle de .npc-acc-main, sinon la vignette
       atterrit tout en bas de la page au lieu d etre au-dessus des produits. */
    var zone = res.querySelector('.npc-acc-main') || res;
    var grille = zone.querySelector('.mz-so-gong-grid, .mz-so-grid');
    if (!grille) grille = res.querySelector('.mz-so-gong-grid, .mz-so-grid');
    if (!grille) return;

    var c = champ();
    var q = (c && c.value ? c.value : '').trim();
    var ancien = res.querySelector('.alm-socols');
    if (ancien && ancien.dataset.q === q) {
      /* La grille reelle (.npc-acc-main) est construite APRES notre premiere pose :
         au tour suivant, on replace simplement la bande au bon endroit. */
      if (grille && ancien.nextElementSibling !== grille) {
        if (ancien.__titre) grille.parentNode.insertBefore(ancien.__titre, grille);
        grille.parentNode.insertBefore(ancien, grille);
      }
      return;
    }
    if (ancien) { if (ancien.__titre) ancien.__titre.remove(); ancien.remove(); }
    if (q.length < 2) return;

    var box = document.createElement('div');
    box.className = 'alm-socols';
    box.dataset.q = q;
    var titre = document.createElement('p');
    titre.className = 'alm-socols-titre';
    titre.textContent = 'Collections';
    box.dataset.titre = '1';
    grille.parentNode.insertBefore(titre, grille);
    grille.parentNode.insertBefore(box, grille);
    box.__titre = titre;

    if (cache[q]) { dessiner(box, cache[q]); return; }

    fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=collection&resources[limit]=8', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var cols = (d && d.resources && d.resources.results && d.resources.results.collections) || [];
        cache[q] = cols;
        if (!cols.length) { if (box.__titre) box.__titre.remove(); box.remove(); return; }
        if (document.body.contains(box)) dessiner(box, cols);
      })
      .catch(function () { if (box.__titre) box.__titre.remove(); box.remove(); });
  }

  /* 01/09 - DEMARRAGE PAR SONDAGE, et non par observation.
     Les tentatives precedentes (MutationObserver + ecouteur sur le champ) ne se
     declenchaient jamais : le panneau de resultats est reconstruit par un autre
     script, qui remplace le noeud observe. Plutot que de courir apres, on regarde
     simplement l etat toutes les 500 ms. C est negligeable en cout car `poser()`
     sort immediatement si rien n a change (drapeau data-q sur le conteneur). */
  setInterval(poser, 500);
  document.addEventListener('input', function (e) {
    if (e.target && e.target.id === 'mzSoInput') poser();
  });
})();

})();
